// export const apiUrl = "http://192.168.100.104:8000";
 export const apiUrl = "https://backend.inkox.com";
  // export const apiUrl = "http://192.168.100.50:80s00";
// export const apiUrl = "http://192.168.100.104:8000";

export const stripePublishableKey = "pk_test_51Q2XZHASGTzYRaXbOk8OerF17IowjpqLF9WwxpFQ7ukeMIL7kU39b6IT01YIoNYc2Q2A6Z2iX59jIq6Ork5BNfLn000nY4X6Q7";
export const googleOAuthClientId = "836612524230-0tolohcdap34h5lcptf1lv62n3o1no98.apps.googleusercontent.com";
export const googleTagManagerId = "GTM-PXNLVW5X";
export const blogUrl = "https://blog.inkofly.com";

export const logintoken = localStorage.getItem("APP_TOKEN");
